// extracted by mini-css-extract-plugin
export default {"contact_container":"Contact_contact_container__LL7lv","contact_container__information":"Contact_contact_container__information__8VJYZ"};